import { IconButton } from '@festina-life/ui/actions'
import { paperStyles } from '@festina-life/ui/libs'
import cx from 'classnames'
import { useState } from 'react'

type Props = {
  /** Scaling step added or subtracted each time the zoom in or zoom out buttons are clicked. */
  step: number
  onChange: (nextScale: number) => void
  onOpenDetails?: () => void
}

export const TimelineScaleControls = ({
  step,
  onChange,
  onOpenDetails,
}: Props) => {
  const [currentScale, setCurrentScale] = useState(1)

  const handleChangeScale = (nextScale: number) => () => {
    if (nextScale >= 1) {
      setCurrentScale(nextScale)
      onChange(nextScale)
    }
  }

  return (
    <div
      className={cx(
        'absolute right-0 hidden group-hover:flex!',
        paperStyles({ isFaded: true }),
      )}
    >
      <IconButton
        iconName="MagnifyingGlassPlus"
        iconSize="md"
        onClick={handleChangeScale(currentScale + step)}
      />
      <IconButton
        iconName="MagnifyingGlassMinus"
        iconSize="md"
        onClick={handleChangeScale(currentScale - step)}
      />
      <IconButton
        iconName="ArrowPath"
        iconSize="md"
        onClick={handleChangeScale(1)}
      />
      {onOpenDetails && (
        <IconButton
          iconName="ArrowTopRightOnSquare"
          iconSize="md"
          onClick={onOpenDetails}
        />
      )}
    </div>
  )
}
